import { EMPTY_ITEM_RIGHTS_COLLECTION } from "Global/Base/Rights/RightTypes";
import { Localization } from "OW.Remoting/Remoting/Localization";
import { Key } from "../../../../Global/Base/Utils/EventUtils";
import { createElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { ControlParams } from "./ControlInterfaces";
import { Edit } from "./Edit";

export class PasswordEdit extends Edit {
    //#region Fields
    private _isPassword: boolean;
    private _showButton: HTMLElement;
    private _showButtonVisible: boolean = true;
    //#endregion Fields

    //#region Constructors
    public static createWithEmptyRights(element: HTMLElement): PasswordEdit {
        return new PasswordEdit({ element, originalRightsDefinition: EMPTY_ITEM_RIGHTS_COLLECTION });
    }

    constructor(params: ControlParams) {
        super(params);
        this.element.classList.add("password");
        this._isPassword = true;
        this.innerElement.type = "password";
        this._createShowButton();
    }
    //#endregion Constructors

    //#region Properties
    /**
     * Příznak, zda se má zobrazovat tlačítko na dočasné odkrytí znaků hesla
     */
    public get showButtonVisible(): boolean {
        return this._showButtonVisible;
    }

    public set showButtonVisible(value: boolean) {
        if (this._showButtonVisible && !value && this._showButton && this.element.contains(this._showButton)) {
            this.element.removeChild(this._showButton);
        } else if (!this._showButtonVisible && value && this._showButton != null && !this.element.contains(this._showButton)) {
            this.element.appendChild(this._showButton);
        }
        this._showButtonVisible = value;
    }
    //#endregion Properties

    //#region Methods
    private _setPasswordVisibilityState(visible: boolean): void {
        if (this._showButton.classList.contains("Disabled")) {
            return;
        }
        this._setIsPassword(!visible);
        this._showButton.classList.toggle("mouse-down", visible);
        !visible && this.innerElement.focus();
    }
    /**
     * Vytvoří tlačítko pro odkrytí hesla
     */
    private _createShowButton(): void {
        if (this._showButtonVisible && this._isPassword) {
            const buttonElement = createElement({ type: "button", attrs: { "type": "button" }, classes: "valuepicker unhide-password" });
            // oprava unhide passwordu
            buttonElement.addEventListener("touchstart", (e: TouchEvent) => {
                e.preventDefault();
                if (buttonElement === document.activeElement) {
                    buttonElement.blur();
                } else {
                    buttonElement.focus();
                }
                this._setIsPassword(!this._isPassword);
            });
            buttonElement.addEventListener("mousedown", (e) => {
                if (e.button === 0) { // Levé tlačítko myši
                    this._setPasswordVisibilityState(true);
                }
            });
            buttonElement.addEventListener("mouseup", (e) => {
                if (e.button === 0) { // Levé tlačítko myši
                    this._setPasswordVisibilityState(false);
                }
            });
            buttonElement.addEventListener("keydown", (e) => {
                if (e.key === Key.Enter || e.key === Key.Space) {
                    this._setPasswordVisibilityState(true);
                }
            });
            buttonElement.addEventListener("keyup", (e) => {
                if (e.key === Key.Enter || e.key === Key.Space) {
                    this._setPasswordVisibilityState(false);
                }
            });
            buttonElement.addEventListener("mouseout", (e) => {
                if (e.target === buttonElement && !this._isPassword) {
                    this._setPasswordVisibilityState(false);
                }
            });
            Localization.addLocData(buttonElement, "GUI-798679", ["title", "ariaLabel"]); // Přepnout viditelnost hesla
            this._showButton = buttonElement;

            this.element.appendChild(buttonElement);
        }
    }

    /**
     * Přepíná mód hesla - skrytí znaků
     */
    private _setIsPassword(value: boolean): void {
        this._isPassword = value;
        //chrome zrusi change event pri zmene typu inputu - neposle se setValue
        setTimeout(() => {
            this.innerElement.type = (this._isPassword) ? "password" : "text";
        }, 0);
    }

    //#endregion Methods
}
